// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let OrderEditUpdateData = function (
    dpDict, tradingDataDict, sessionSettingsChanged, placedFrom)
{
    this.dpDict = dpDict
    this.tradingDataDict = tradingDataDict
    this.sessionSettingsChanged = sessionSettingsChanged
    this.placedFrom = placedFrom
}